<mat-chip-grid #chipGrid class="chip-grid" [disabled]="disabled">
  <mat-chip-row *ngFor="let item of displayedValueItems()" (removed)="removeValueItem(item)" class="chip-row">
    {{ getDisplayName(item) }}
    <button *ngIf="!disabled" matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>

  <input
    #value
    matInput
    [matChipInputFor]="chipGrid"
    [formControl]="valueInputControl"
    (input)="onInput($event)"
    (focus)="onFocus($event)"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut()"
    [matAutocomplete]="autocomplete"
    [matAutocompleteConnectedTo]="autocompleteOrigin"
  />
  <mat-autocomplete #autocomplete="matAutocomplete" requireSelection [displayWith]="autocompleteDisplayWith" autoActiveFirstOption>
    <mat-option *ngFor="let option of filteredOptions()" [value]="option">
      {{ getDisplayName(option) }}
    </mat-option>
  </mat-autocomplete>
</mat-chip-grid>
